import { locale } from 'devextreme/localization'

export const formatDateTime = (input, asElement = false) => {
    // Check if input is valid
    if (!input) {
        console.error('Input is undefined or null')
        return asElement ? <span></span> : ''
    }

    const value =
        input instanceof Date ? input : input && typeof input === 'object' ? input.value : input

    // Check if value is null
    if (!value) {
        console.error('Input value is falsy')
        return asElement ? <span></span> : ''
    }

    // Attempt to create a Date object
    const date = new Date(value)

    // Check if the date is valid
    if (isNaN(date.getTime())) {
        console.error('Invalid date:', value)
        return asElement ? <span></span> : ''
    }

    // Format the date
    const formattedDate = new Intl.DateTimeFormat(locale.languageTag, {
        timeStyle: 'medium',
        dateStyle: 'short',
        hour12: true,
    }).format(date)

    // Return as a React element or as a string based on the asElement flag
    return asElement ? <span>{formattedDate}</span> : formattedDate
}

export const formattedDate = (input, asElement = false) => {
    const value =
        input instanceof Date ? input : input && typeof input === 'object' ? input.value : input
    if (!value) return asElement ? <span></span> : ''

    const date = new Date(value)
    const formattedDateString = new Intl.DateTimeFormat(locale.languageTag, {
        dateStyle: 'short',
    }).format(date)

    // Return as a React element or as a string based on the asElement flag
    return asElement ? <span>{formattedDateString}</span> : formattedDateString
}

export const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleString([], {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    })
}
